import { Link, NavLink, useLocation } from "react-router-dom";
import { NavArrowRight } from "iconoir-react";
import "./Header.css";

const HIDDEN_ON = ["/login", "/register", "/check-email", "/verify-email"];

export default function Header() {
  const loc = useLocation();
  if (HIDDEN_ON.some((p) => loc.pathname.startsWith(p))) return null;

  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="brand">
          <span className="brand__mark" aria-hidden>
            <span className="brand__mark-g">g</span>
          </span>
          <span className="brand__word">
            strinova<span className="brand__dot">.</span>guru
          </span>
        </Link>

        <nav className="site-nav">
          <NavLink to="/" end className={({ isActive }) => (isActive ? "is-active" : "")}>
            directory
          </NavLink>
          <a href="#recommendations">recommendations</a>
          <a href="#filters">filters</a>
          <a href="mailto:hello@strinova.guru">contact</a>
        </nav>

        <div className="site-header__actions">
          <Link to="/login" className="btn btn-ghost site-header__login">
            log in
          </Link>
          <Link to="/register" className="btn btn-primary">
            join
            <NavArrowRight width={18} height={18} />
          </Link>
        </div>
      </div>
    </header>
  );
}
